import { render, staticRenderFns } from "./school-add.vue?vue&type=template&id=3eb3cad2&"
import script from "./school-add.vue?vue&type=script&lang=js&"
export * from "./school-add.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports